export enum ELoaderSkeletonBlockView {
  Input = 'input',
  Text = 'text'
}
